import React, { PropsWithChildren } from 'react'

import { BorderStyle, Box, Color, DisplayPosition } from '@gousto-internal/citrus-react'

type ContentMaskProps = {
  className?: string
  variant?: 'dark' | 'light'
}

export const ContentMask = ({
  className = '',
  children,
  variant = 'dark',
}: PropsWithChildren<ContentMaskProps>) => {
  const isDark = variant === 'dark'

  return (
    <Box className={className} data-testid="content-mask">
      <Box
        bg={isDark ? Color.ColdGrey_800 : Color.White}
        borderBottomWidth={0.5}
        borderTopWidth={0.5}
        borderColor={isDark ? Color.ColdGrey_800 : Color.ColdGrey_200}
        borderStyle={BorderStyle.Solid}
        color={isDark ? Color.White : Color.ColdGrey_800}
        position={DisplayPosition.Relative}
      >
        <Box paddingBottom={10} paddingV={4}>
          {children}
        </Box>
      </Box>
    </Box>
  )
}
